



























import Vue, { PropType } from "vue";

import RestClient, { RestError } from "../../RestClient";
import MainTabbar from "../general/MainTabbar.vue";

import ClientsAddresses from "./ClientsAddresses.vue";
import ClientsAccounts from "./ClientsAccounts.vue";
import ClientsAll from "./ClientsAll.vue";

import SettingsJson from "../../shared/SettingsJson";
import SettingsNotificationsJson from "../../shared/SettingsNotificationsJson";
import UserJson from "../../shared/UserJson";
import ModulesJson, { checkModuleIsActivated } from "../../shared/ModulesJson";
import { checkPermission } from "../../shared/UserPermission";
import { UserPermissionType } from "../../shared/UserPermissionType";

export default Vue.extend({
  name: "Clients",
  components: {
    MainTabbar,
    ClientsAddresses,
    ClientsAccounts,
    ClientsAll,
  },
  props: {
    restClient: RestClient,
    loginUser: Object as PropType<UserJson>,
    loginId: Number,
    loginPermission: Number,
    settings: Object as PropType<SettingsJson>,
    settingsNotifications: Object as PropType<SettingsNotificationsJson>,
    appFrameClickedButton: Object,
    allActiveModules: Array as PropType<ModulesJson[]>,
    userActiveModules: Array as PropType<ModulesJson[]>,
  },
  data() {
    return {
      currentMainTabbarTab: "",
      checkModuleIsActivated: checkModuleIsActivated,
      checkPermission: checkPermission,
    };
  },
  created() {},
  methods: {
    changeMainTabbarTab: function (tab: string) {
      this.currentMainTabbarTab = tab;
    },
  },
  computed: {
    mainTabbarItems(): ModulesJson[] {
      let vue = this;

      return [
        {
          title: "Adressen",
          linkedComponent: "ClientsAddresses",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleClients),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleClients),
        },

        {
          title: "Accounts",
          linkedComponent: "ClientsAccounts",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleAccounts),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleAccounts),
        },

        {
          title: "Alle",
          linkedComponent: "ClientsAll",
          permissionRank: 2,
          userPermission: null,
          isDisabled: !vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleClients),
          isDisplayed: vue.checkPermission(vue.loginUser, 2, UserPermissionType.moduleClients),
        },
      ] as ModulesJson[];
    },
  },
});
